// extracted by mini-css-extract-plugin
module.exports = {"banco":"Banco_banco__-GUs2","bancoBtn":"Banco_bancoBtn__3sQwK","selected":"Banco_selected__2Y2oD"};